<iframe [src]="url | safe" frameborder="0" style="overflow:scroll; width: 100%; height: 100vh;"></iframe>


// WEBPACK FOOTER //
// ./src/app/main/content/help/help.component.html